export default __webpack_public_path__ + "static/media/line2.6c31938b.png";